import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import profile from './profile.reducer';
import company from './company.reducer';
import statements from './statements.reducer';
import statementItem from './statementItem.reducer';
import job from './job.reducer';
import jobItem from './jobItem.reducer';
import auth from './auth.reducer';
import media from './media.reducer';
import team from './team.reducer';
import teamMember from './teamMember.reducer';
import user from './user.reducer';
import discover from './discover.reducer';
import channel from './channel.reducer';
import watchlist from './watchlist.reducer';
import analytics from './analytics.reducer';
import notifications from './notifications.reducer';
import filter from './filter.reducer';
import search from './search.reducer';
import intake from './intake.reducer';
import adminTalentScorecards from './admin/talentScorecards.reducer';
import adminTalentScorecard from './admin/talentScorecard.reducer';
import adminTalentScorecardValues from './admin/talentScorecardOptions.reducer';
import adminTalentFilters from './admin/filter.reducer';
import NIL from './nil/NIL.reducer';
import NILList from './nil/NILList.reducer';
import NILApplications from './nil/NILApplications.reducer';
import originals from './originals/originals.reducer';
import original from './originals/original.reducer';

const appReducer = combineReducers({
  adminTalentScorecardValues,
  adminTalentScorecards,
  adminTalentScorecard,
  adminTalentFilters,
  profile,
  company,
  statements,
  statementItem,
  job,
  jobItem,
  auth,
  media,
  team,
  teamMember,
  user,
  discover,
  channel,
  watchlist,
  analytics,
  notifications,
  filter,
  search,
  intake,
  NIL,
  NILList,
  NILApplications,
  originals,
  original,
});

export default (state, action) => {
  if (action?.type === 'AUTH_LOGOUT_API_SUCCESS') {
    storage.removeItem('persist:root');
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
